import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import Input from "../../components/input";

const AddMore = ({ isAddMoreOpen, closeAddMoreModal, handleAddService }) => {
  const [newService, setNewService] = useState({
    serviceName: "",
    apiKey: "",
    apiSecret: "",
    serviceType: "PAYMENT_GATEWAY",
    additionalData: ""
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let formErrors = {};
    if (!newService.serviceName.trim()) formErrors.serviceName = "Service Name is required";
    if (!newService.serviceType) formErrors.serviceType = "Service Type is required";
    if (!newService.apiKey.trim()) formErrors.apiKey = "API Key is required";
    if (!newService.apiSecret.trim()) formErrors.apiSecret = "API Secret is required";
    
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleAdd = () => {
    if (!validateForm()) return;
    handleAddService(newService, 'add');
    closeAddMoreModal();
  };

  return (
    <Modal show={isAddMoreOpen} onHide={closeAddMoreModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Add New Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="mb-3">
            <Input
              label="Service Name"
              placeholder="Service Name"
              type="text"
              value={newService.serviceName}
              onChange={(e) => setNewService({ ...newService, serviceName: e.target.value })}
              required={true}
            />
            {errors.serviceName && <div className="form-error-message">{errors.serviceName}</div>}
          </div>
          <div className="mb-3">
            <Input
              label="Service Type"
              placeholder="Service Type"
              type="select"
              options={[
                { value: "PAYMENT_GATEWAY", label: "Payment Gateway" },
                { value: "OTP_SERVICE", label: "OTP Service" },
                { value: "MAP_SERVICE", label: "Map Service" },
              ]}
              value={newService.serviceType}
              onChange={(e) => setNewService({ ...newService, serviceType: e.target.value })}
              required={true}
            />
            {errors.serviceType && <div className="form-error-message">{errors.serviceType}</div>}
          </div>
          <div className="mb-3">
            <Input
              label="API Key"
              placeholder="API Key"
              type="text"
              value={newService.apiKey}
              onChange={(e) => setNewService({ ...newService, apiKey: e.target.value })}
              required={true}
            />
            {errors.apiKey && <div className="form-error-message">{errors.apiKey}</div>}
          </div>
          <div className="mb-3">
            <Input
              label="API Secret"
              placeholder="API Secret"
              type="text"
              value={newService.apiSecret}
              onChange={(e) => setNewService({ ...newService, apiSecret: e.target.value })}
              required={true}
            />
            {errors.apiSecret && <div className="form-error-message">{errors.apiSecret}</div>}
          </div>
          <div className="mb-3">
            <Input
              label="API Webhook Secret"
              placeholder="API Webhook Secret"
              type="text"
              value={newService.additionalData}
              onChange={(e) => setNewService({ ...newService, additionalData: e.target.value })}
            />
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Add Service" callBack={handleAdd} />
      </Modal.Footer>
    </Modal>
  );
};

export default AddMore;